import { Card } from "@/components/common";

export function SetupScoreGauge({ score }) {
  if (!score) return null;
  const val = score.score;
  const color = val >= 75 ? "#21C58E" : val >= 50 ? "#F5B942" : "#EF6262";
  const r = 52, c = 2 * Math.PI * r;
  const off = c * (1 - val / 100);
  const labels = {
    htf_alignment: "HTF Alignment", regime: "Regime", structure: "Structure",
    location: "Key Location", confirmation: "Confirmation", momentum: "Momentum",
    rr: "Risk / Reward", news: "News Env.", volatility: "Volatility / Spread",
  };
  return (
    <Card className="p-5" data-testid="setup-score-card">
      <div className="text-xs uppercase tracking-wider text-[var(--text-muted)] mb-3">Setup Quality Score</div>
      <div className="flex items-center gap-5">
        <div className="relative shrink-0" style={{ width: 128, height: 128 }}>
          <svg width="128" height="128" className="-rotate-90">
            <circle cx="64" cy="64" r={r} fill="none" stroke="var(--border2)" strokeWidth="10" />
            <circle cx="64" cy="64" r={r} fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
              strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.16,1,0.3,1)" }} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="tnum text-3xl font-bold" style={{ color }} data-testid="setup-quality-score">{val}</span>
            <span className="text-[10px] text-[var(--text-muted)]">/ 100</span>
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold mb-2" style={{ color }}>{score.grade}</div>
          <div className="space-y-1.5">
            {Object.entries(score.breakdown).map(([k, v]) => {
              const max = score.weights[k];
              const pct = max ? (v / max) * 100 : 0;
              return (
                <div key={k} className="flex items-center gap-2" title={`${labels[k]}: ${v}/${max}`}>
                  <span className="text-[11px] text-[var(--text-sec)] w-24 truncate">{labels[k]}</span>
                  <div className="flex-1 h-1.5 rounded-full bg-[var(--border2)] overflow-hidden">
                    <div className="h-full rounded-full" style={{ width: `${pct}%`, background: pct >= 66 ? "#21C58E" : pct >= 33 ? "#F5B942" : "#EF6262" }} />
                  </div>
                  <span className="tnum text-[11px] text-[var(--text-muted)] w-10 text-right">{v}/{max}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <p className="mt-3 text-[11px] text-[var(--text-muted)]">Score reflects how well conditions fit your plan. It is not a probability of winning.</p>
    </Card>
  );
}
